import { useContext } from 'react';
import { DARK, USER_ROLE_KEYS } from '../../utilities/constants';
import { UserRolesAndPermissionsContext } from '../../context/UserRolesAndPermissionsContext';
import { useCompanyManagement } from '../../pages/ExecutiveConsole/components/hooks/useCompanyManagement';
import { useLocation } from 'react-router-dom';
import { ConfigProvider, Select, Spin, Typography } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as SelectDropdownSvg } from '../../assets/icons/select-dropdown.svg';
import { ReactComponent as SelectDropdownBlackSvg } from '../../assets/icons/select-dropdown-black.svg';
import { secureStorage } from '../../utilities/securityUtils';
import { useAuth } from '../../context/AuthContext';
import { ErrorMessageContext } from '../../context/ErrorMessageContext';
import { useTheme } from '../../context/ThemeContext';

const { Text } = Typography;

const OrganisationChange = () => {
  const { userRole, selectedOrg, setSelectedOrg, userDetails } = useContext(
    UserRolesAndPermissionsContext
  );
  const { orgList } = useCompanyManagement();
  const { fetchTokenForOrg, isOrgSwitching } = useAuth();
  const location = useLocation();
  const { addErrorMessage } = useContext(ErrorMessageContext);
  const { theme } = useTheme();

  const handleOrgChange = async value => {
    try {
      const success = await fetchTokenForOrg(value);
      if (success) {
        secureStorage.setItem('selectedOrg', value);
        setSelectedOrg(value);
      } else {
        addErrorMessage(
          'Failed to switch organization! Please try again after sometime.'
        );
      }
    } catch {
      addErrorMessage(
        'Failed to switch organization! Please try again after sometime.'
      );
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            selectorBg: 'var(--content-bg-color, #000000)',
          },
        },
      }}
    >
      {(userRole === USER_ROLE_KEYS.SUPER_ADMIN ||
        userRole === USER_ROLE_KEYS.PLATFORM_OPERATION_MANAGER) &&
      !location.pathname.includes('super-admin-console') &&
      !location.pathname.includes('platform-operations-console') ? (
        <>
          <Select
            options={orgList}
            value={orgList?.length !== 0 && selectedOrg}
            size="small"
            style={{ minWidth: 250, height: 38 }}
            onChange={handleOrgChange}
            loading={isOrgSwitching}
            disabled={isOrgSwitching}
            suffixIcon={
              <Icon
                component={
                  theme === DARK ? SelectDropdownSvg : SelectDropdownBlackSvg
                }
                style={{
                  pointerEvents: 'none',
                }}
              />
            }
          />
        </>
      ) : (
        <Text strong style={{ fontSize: 20 }}>
          {userDetails?.org}
        </Text>
      )}
      {isOrgSwitching && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.35)',
          }}
        >
          <Spin size="large" />
        </div>
      )}
    </ConfigProvider>
  );
};

export default OrganisationChange;
